module.exports = __webpack_public_path__ + "static/img/0200.b9083e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0200.jpg
// module id = Qxbf
// module chunks = 0